/* istanbul ignore file */

export { PromotionBanner as default } from "./PromotionBanner";
